module App.Classes {
    export interface ILicensePlateInformation {
        brand: string
        type: string
        constructionYear: number
        fuel: string
        kw: number
        cilinderCapacity: number
        found: boolean
        newWebColor: Interfaces.IWebsiteColor
        customCarDescription: string
        nextApkDate: Date
        apkIsValid: boolean
        licensePlate: string
    }

    export class LicensePlateInformation implements ILicensePlateInformation {
        customCarDescription: string
        brand: string
        type: string
        constructionYear: number
        fuel: string
        kw: number
        cilinderCapacity: number
        found: boolean        
        newWebColor: Interfaces.IWebsiteColor        
        nextApkDate: Date
        apkIsValid: boolean
        licensePlate: string
    }
}